export default __webpack_public_path__ + "static/media/Empresa de Economia Criativa.803fbe0d.png";